import { BundleResourcesPackage } from "resource-system";
import { Spritesheet } from "pixi.js";
import { Texture } from "@pixi/core";
export class VictoryResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("VictoryResourcesPackage");
    }
    public get assets_popups_victory_victory_1x_atlas_json(): Spritesheet {
        return this.resource<Spritesheet>("assets/popups/victory/victory_1x.atlas.json");
    }
    public get assets_popups_victory_win_frame_png(): Texture {
        return this.assets_popups_victory_victory_1x_atlas_json.textures["win_frame.png"];
    }
    public get assets_popups_victory_purple_ribbon_png(): Texture {
        return this.assets_popups_victory_victory_1x_atlas_json.textures["purple_ribbon.png"];
    }
    public get assets_popups_victory_shop_substrate_png(): Texture {
        return this.assets_popups_victory_victory_1x_atlas_json.textures["shop_substrate.png"];
    }
    public get assets_popups_victory_coins_reward_substrate_png(): Texture {
        return this.assets_popups_victory_victory_1x_atlas_json.textures["coins_reward_substrate.png"];
    }
    public get assets_popups_victory_vegetables_reward_substrate_png(): Texture {
        return this.assets_popups_victory_victory_1x_atlas_json.textures["vegetables_reward_substrate.png"];
    }
    public get assets_popups_victory_multiplier_ad_button_png(): Texture {
        return this.assets_popups_victory_victory_1x_atlas_json.textures["multiplier_ad_button.png"];
    }
    public get assets_popups_victory_buster_purchase_substrate_png(): Texture {
        return this.assets_popups_victory_victory_1x_atlas_json.textures["buster_purchase_substrate.png"];
    }
    public get assets_popups_victory_next_level_icon_png(): Texture {
        return this.assets_popups_victory_victory_1x_atlas_json.textures["next_level_icon.png"];
    }
    public get assets_popups_victory_victory_1x_atlas_png(): Texture {
        return this.resource<Texture>("assets/popups/victory/victory_1x.atlas.png");
    }
}

